import { useState } from "react"

const useAnalysisControls = () => {

  const [showOverlay, setShowOverlay] = useState<boolean>(false)
  const [showHighlightMin, setShowHighlightMin] = useState<boolean>(false)
  const [showHighlightMax, setShowHighlightMax] = useState<boolean>(false)

  return [{
    overlayAnalysisCheckbox: {value: showOverlay, onChange: () => setShowOverlay(!showOverlay)},
    minHighlightCheckbox: {value: showHighlightMin, onChange: () => setShowHighlightMin(!showHighlightMin)},
    maxHighlightCheckbox: {value: showHighlightMax, onChange: () => setShowHighlightMax(!showHighlightMax)},
  }]
}

export default useAnalysisControls